import React from 'react'
import { useState, useEffect } from 'react'
import { LostConnection } from '../../constant';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { useHistory } from 'react-router-dom';
import { validarSesion } from '../tokens/useToken';
import { useForm } from '../forms/useForm';
import { usePagination } from '../pagination/usePagination';


export const useIndicationsPatients = () => {


    const [createSweet] = useSweetAlert();
    const history = useHistory();

    //MODAL INDICATION CREATE
    const [method, setMethod] = useState("");
    const [modal, setModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [loading, setLoading] = useState(false);

    //MODAL SEND CSV
    const [modal2, setModal2] = useState(false);
    const [method2, setMethod2] = useState("");
    const [modalTitle2, setModalTitle2] = useState("");

    const [listIndications, setListIndications] = useState([]);
    const [indicationId, setIndicationId] = useState(0)

    // ? CONFIGURATION INDICATION
    const [viewIndication, setViewIndication] = useState(1);

    //? SEARCH INDICATIONS PATIENT
    const [searchIndicationsP, setSearchIndicationsP] = useState("");
    const [loadingExcel, setLoadingExcel] = useState(false);

    //? DELETED DIALOG
    const [modalAlert, setModalAlert] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);

    const [formValues, handleInputChange, reset, handleUpdateValues, handleSelectValues, handlePickerValues] = useForm({
        id_exam_indication: 0,
        indication: "",

    });

    const { id_exam_indication, indication } = formValues;

    // * CONFIGURATION TABS 
    const handleIndication = (_view) =>
    {
        if (_view !== undefined && _view !== "") {            
            setViewIndication(_view)
        }
    }

    // ////console.log(formValues);

    const numberItems = 5;

    const { totalPageCount, currentPage, nextPage, previousPage, goToPage } = usePagination(listIndications.length, numberItems);

    useEffect(() => {
        let startItems = 0;
        let endItems = numberItems;

        let aux = numberItems * currentPage;

        endItems = aux;

        startItems = endItems - numberItems;
        let listInd = [];
        listIndications.forEach((data, key) => {

            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listInd.push({
                ...data,
                visibleTable: visibleTable
            });
        });

        setListIndications(listInd);

    }, [totalPageCount, currentPage])

    const [validaciones, SetValidaciones] = useState({
        id_exam_indication_valid: false,
        indication_valid: false,
    });


    useEffect(() => {

        getExamIndication();

    }, [history.location])


    const openDialog = (title, mode) => {
        setModalTitle(title);
        setMethod(mode);
        setModal(true);
    };

    const closeDialog = () => {
        setModal(false);
    };

    const openDeleteAlert = () => {
        setShowDeleteAlert(true); 
        setModalAlert(true);  
    };

    const closeDeleteAlert = () => {
        setModalAlert(false);   
    };
    

    const toggle2 = () => {
        setModal2(!modal2)

    }


    const getExamIndication = async () => {

        let requestOptions = {
            method: 'GET'
        };

        let ListIndication = [];

        const respuesta = await sendRequest(requestOptions, "ExamIndication/List");


        if (respuesta.code === 200) {


            if (respuesta.data.length >= 1) {

                let startItems = 0;
                let endItems = numberItems;
                let aux = numberItems * currentPage;

                endItems = aux;

                startItems = endItems - numberItems;

                respuesta.data.forEach((value, index) => {

                    let posicion = index + 1;
                    let visibleTable = false;

                    if (posicion > startItems && posicion <= endItems) {
                        visibleTable = true;
                    }

                    ListIndication.push({
                        id_exam_indication: value.id_exam_indication,
                        indication: value.indication,
                        visibleTable: visibleTable
                    });
                });
                setListIndications(ListIndication);
                setIndicationData(ListIndication);
            }
            else {
                //createSweet("error", "error", "Hubo un error!", "No se encontraron las indicaciones");
                setListIndications([]);
            }
        }
        else if (respuesta.code === 401) {

            validarSesion(history, respuesta.code, getExamIndication);
        }
        else if (respuesta.code === 500) {

            createSweet("error", "error", "Indicaciones", "Ocurrio un problema en el servidor");
        }
        else {

            createSweet("error", "warning", "Indicaciones", respuesta.data.msg);
        }
    };


    //CREATE  INDICATION
    const handleCreate = () => {

        handleUpdateValues({
            id_exam_indication: 0,
            indication: ""
        });

        setIndicationId(0);
        setMethod("create");
        setModalTitle("Crear Indicaciones para el exámen");
        openDialog("Crear indicaciones para pacientes", "create");
    };

    //SEND CSV
    const handleSendCSV = () => {

        setMethod2("listCSV");
        setModalTitle2("Cargar archivo CSV")
        toggle2();

    }



    const saveCreate = async (e) => {
        e.preventDefault();
        setLoading(true);


        if (validarForm()) {
            setLoading(false);
            return;
        }

        let mData = formValues;

        let requestOptions = {
            method: 'POST',
            body: JSON.stringify(mData)
        };

        const respuesta = await sendRequest(requestOptions, "ExamIndication/Create");
        if (respuesta.code === 200) {

            getExamIndication();
            reset();
            createSweet("create", "success", "Exito!", "Indicaciones creadas exitosamente");
            setLoading(false);
            closeDialog();
        }
        else if (respuesta.code === 401) {

            validarSesion(history, respuesta.code, saveCreate);
        }
        else if (respuesta.code === 500) {

            createSweet("error", "error", "Indicaciones", "Ocurrio un problema en el servidor");
        }
        else {

            createSweet("error", "warning", "Indicaciones", respuesta.data.msg);
        }
    }


    const handleUpdate = (id_exam_indication) => {

        let reason = listIndications.find(b => b.id_exam_indication === parseInt(id_exam_indication));

        handleUpdateValues({
            id_exam_indication: reason.id_exam_indication,
            indication: reason.indication
        });

        setIndicationId(id_exam_indication);
        setMethod("update");
        setModalTitle("Modificar las indicaciones del exámen");
        openDialog("Modificar la indicación", "update");
    }


    const saveUpdate = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }


        let body = {
            id_exam_indication: indicationId,
            ...{ ...formValues }
        };

        let requestOptions = {
            method: 'PUT',
            body: JSON.stringify(body)
        };

        const respuesta = await sendRequest(requestOptions, "ExamIndication/Update");

        if (respuesta.code === 200) {
            getExamIndication();
            createSweet("create", "success", "Exito!", "Indicación actualizada");
            setLoading(false);
            closeDialog();
        }
        else if (respuesta.code === 401) {
            setLoading(false);
            validarSesion(history, respuesta.code, saveUpdate);
        }
        else if (respuesta.code === 500) {
            setLoading(false);
            createSweet("error", "error", "Grafica", "Ocurrio un problema en el servidor");
        }
        else {
            setLoading(false);
            createSweet("error", "warning", "Grafica", respuesta.data.msg);
        }
        // else {
        //     createSweet("error", "error", "Hubo un error!", LostConnection);
        //     setLoading(false);
        //     validarSesion(history, respuesta.code, saveUpdate);
        // }
    };

    const handleDelete = (id_exam_indication) => {

        let reason = listIndications.find(b => b.id_exam_indication === parseInt(id_exam_indication));

        handleUpdateValues({
            indication: reason.indication
        });
        setIndicationId(id_exam_indication);
        setMethod("delete");
        setModalTitle("Eliminar indicación");
        openDeleteAlert();
    };

    const saveDelete = async (e) => {
        e.preventDefault();

        setLoading(true);

        let requestOptions = {
            method: 'DELETE'
        };

        const respuesta = await sendRequest(requestOptions, `ExamIndication/Delete/${indicationId}`);

        if (respuesta.code === 200) {
            getExamIndication();
            setLoading(false);
            createSweet("create", "success", "Exito!", "Indicación Eliminada");
            closeDeleteAlert();
        }
        else if (respuesta.code === 401) {
            setLoading(false);
            validarSesion(history, respuesta.code, saveDelete);
        }
        else if (respuesta.code === 500) {
            setLoading(false);
            createSweet("error", "error", "Indicaciones", "Ocurrio un problema en el servidor");
        }
        else {
            setLoading(false);
            createSweet("error", "warning", "Indicaciones", respuesta.data.msg);
        }
    };

    //SUBIR ARCHIVO CSS
    const ExamIndication = async (event) => {

        setLoading(true);

        try {

            const selectedFile = event.files?.[0] || file;

            if (!selectedFile) {
                createSweet( "error", "warning", "Archivo", "Selecciona un archivo CSV");
                setLoading(false);
                return;
            }

            const formData = new FormData();

            formData.append( 'csvFile', selectedFile);

            formData.append( 'type', 0 );

            let requestOptions = {
                method: 'POST',
                body: formData
            };

            const respuesta =
                await sendRequest( requestOptions, "Exam/UploadCsvExamIndications", 'multipart/form-data' );

            if (respuesta.code === 200) {

                getExamIndication();

                createSweet("create", "success","Éxito", "Indicaciones actualizadas");
                toggle2();
            }

            else if (respuesta.code === 401) {

                validarSesion(
                    history,
                    respuesta.code,
                    ExamIndication
                );

            }

            else {

                createSweet( "error", "warning", "Indicaciones", respuesta?.data?.msg);            }

        } catch(error){

            console.log(error);
        }

        setLoading(false);

    };


    const [file, setFile] = useState(null);

    const handleOnChange = (event) => {

        const selectedFile = event.files?.[0];

        if (selectedFile) {
            setFile(selectedFile);
        }

    };

    const validarForm = () => {

        let statusValidacion = false;
        let newValidaciones = {};

        if (formValues.indication === "") {
            newValidaciones = {
                ...newValidaciones,
                indication_valid: true
            }
            statusValidacion = true;
        }
        else {
            newValidaciones = {
                ...newValidaciones,
                indication_valid: false
            };
        }

        SetValidaciones(newValidaciones);
        return statusValidacion;
    };
    const [indicationData, setIndicationData] = useState([]);

    const handleSearchIndicationsP = (e) => {
        setSearchIndicationsP(e);

        let busqueda = e.toUpperCase();
        let newIndications = [];

        if (busqueda === "") {
            setListIndications([...indicationData]);
        } else {

            indicationData.forEach(element => {

                let indication = element.indication?.toUpperCase() || "";

                if (
                    indication.indexOf(busqueda) > -1
                ) {
                    element.visibleTable = true;
                    newIndications.push(element);
                }
            });

            setListIndications([...newIndications]);
        }
    };
    
    const handleClearIndicationsP = () => {
        setSearchIndicationsP("");
        localStorage.removeItem("globalFilter");
        setListIndications(indicationData);
    };


    const handleExcelIndicaionsP = async () => {

        setLoadingExcel(true);

        try {

            const XLSX = await import("xlsx");

            const _report = listIndications.map((item, index) => ({
                "#": index + 1,
                "Indicaciones": item.indication ?? "---"
            }));


            const worksheet = XLSX.utils.json_to_sheet(_report);

            const workbook = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(
                workbook,
                worksheet,
                "Indicaciones Pacientes"
            );

            const excelBuffer = XLSX.write(
                workbook,
                {
                    bookType: "xlsx",
                    type: "array"
                }
            );

            const dataBlob = new Blob(
                [excelBuffer],
                {
                    type:
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                }
            );

            const url = window.URL.createObjectURL(dataBlob);

            const link = document.createElement("a");

            link.href = url;
            link.download = "catalogo_indicaciones_pacientes.xlsx";

            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);

            window.URL.revokeObjectURL(url);

        } catch (error) {

            console.error(
                "Error al exportar Excel",
                error
            );

        }

        setLoadingExcel(false);
    };

    return {
        //LIST INDICATIONS
        listIndications,
        //MODAL CREATE INDICATIONS
        method, modal, modalTitle, loading, closeDialog,
        handleCreate, saveCreate, handleUpdate, saveUpdate, handleDelete, saveDelete, validaciones,
        id_exam_indication, indication, handleInputChange,
        //PAGINATION FRONT-END
        nextPage, previousPage, goToPage, totalPageCount, currentPage,
        //MODAL SEND CSV
        handleSendCSV, modal2, method2, modalTitle2, toggle2, file,
        handleOnChange, ExamIndication,

        // * SEARCH AND DOWNLOAD EXCEL
        searchIndicationsP,
        loadingExcel,
        handleSearchIndicationsP,
        handleClearIndicationsP,
        handleExcelIndicaionsP,

        //* DELETED DIALOG
        showDeleteAlert, modalAlert, closeDeleteAlert


    }
}
